import { type AppSession } from '@/features/reports/api';
import { APP_SESSIONS_COPY as COPY } from '@/features/reports/copy';
import { formatWhen } from '@/lib/format';

/**
 * The session log as a CSV's header and rows: the seven columns the app version log has always
 * exported (ALS-39), now for every row in App usage's window (ALS-160) rather than the page on
 * screen.
 */
export function sessionsCsv(rows: AppSession[]): { header: string[]; rows: string[][] } {
    return {
        header: [
            COPY.columns.name,
            COPY.columns.email,
            COPY.columns.platform,
            COPY.columns.appVersion,
            COPY.columns.action,
            COPY.columns.ip,
            COPY.columns.when,
        ],
        rows: rows.map((row) => [
            row.name,
            row.email ?? '',
            [row.platform, row.osVersion].filter(Boolean).join(' '),
            row.appVersion ?? '',
            row.action,
            row.ipAddress ?? '',
            row.signedInAt ? formatWhen(row.signedInAt) : '',
        ]),
    };
}
